import { lazy } from "react";

const SelfAttendance = lazy(() => import("../Component/Leave/SelfAttendance"));
const ManageLeave = lazy(() => import("../Component/Leave/ManageLeave"));
const MangeEmployeeLeave = lazy(() => import("../Component/Leave/MangeEmployeeLeave"));

const leaveRoutes = [
  { path: "/self-attendance", element: <SelfAttendance />, protected: true },
  { path: "/leave-apply", element: <ManageLeave />, protected: true },
  { path: "/manage-employee-leave", element: <MangeEmployeeLeave />, protected: true },
];

export default leaveRoutes;
